import { HttpContextToken } from '@angular/common/http';

/**
 * Marca una petición para que el interceptor de autenticación no adjunte
 * el token de acceso ni intente refrescar la sesión ante un 401.
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
